// extracted by mini-css-extract-plugin
export default {"splash-container":"SplashScreen-module__splash-container__zln5C","splashContainer":"SplashScreen-module__splash-container__zln5C"};